// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   listScreenings,
//   createScreening,
//   updateScreeningQuestions,
//   sendScreening,
//   cancelScreening,
//   apiErrorMessage,
//   STATUS_LABELS,
//   VERDICT_LABELS,
// } from "../api/screeningApi";
// import { formatDateTime } from "../utils/formatters";
// import "../css/Screening.css";

// const TYPE_OPTIONS = [
//   { value: "TECHNICAL", label: "Technical" },
//   { value: "BEHAVIOURAL", label: "Behavioural" },
//   { value: "GAP", label: "Gap" },
// ];

// // Opens a ready-written Gmail draft to the candidate.
// function gmailComposeUrl({ email, firstName, jobTitle, link, expiresAt }) {
//   const subject = `Your screening interview for ${jobTitle}`;
//   const body = `Hi ${firstName},

// Thank you for your interest in the ${jobTitle} role.

// As the next step, please complete a short voice screening interview (about 15 minutes) using the link below. You'll speak with an AI interviewer that reads each question aloud, and your spoken answers are saved as text for our recruitment team to review.

// ${link}

// Before you start:
// - Use Google Chrome or Microsoft Edge on a laptop or desktop
// - Make sure your microphone works and you're in a quiet room
// - The link works once and expires on ${new Date(expiresAt).toLocaleString()}

// Best regards,
// HirePeaks Consulting`;

//   return (
//     "https://mail.google.com/mail/?view=cm&fs=1" +
//     `&to=${encodeURIComponent(email || "")}` +
//     `&su=${encodeURIComponent(subject)}` +
//     `&body=${encodeURIComponent(body)}`
//   );
// }

// export default function ScreeningPanel({ optimization }) {
//   const optimizationId = optimization?._id || optimization?.id;
//   const candidate = optimization?.candidateId || {};
//   const isDisqualified = optimization?.eligibility?.status === "DISQUALIFIED";
//   // Changes when a final resume is generated on this page, so the panel reloads.
//   const finalResumeKey = optimization?.finalResumeVersion?._id || optimization?.finalResumeVersion?.id || "";

//   const [screenings, setScreenings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [busy, setBusy] = useState(null); // which action is running, e.g. "create" or "send:<id>"
//   const [error, setError] = useState("");
//   const [editing, setEditing] = useState(null); // { id, questions } for the draft being edited
//   const [editError, setEditError] = useState("");
//   const [copiedId, setCopiedId] = useState(null);
//   const [latestFinalVersion, setLatestFinalVersion] = useState(null);

//   useEffect(() => {
//     if (!optimizationId) return;
//     let cancelled = false;
//     (async () => {
//       try {
//         const { data } = await listScreenings(optimizationId);
//         if (!cancelled) {
//           setScreenings(data.screenings || []);
//           setLatestFinalVersion(data.latestFinalVersion ?? null);
//         }
//       } catch (err) {
//         if (!cancelled) setError(apiErrorMessage(err, "Couldn't load screening tests."));
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     })();
//     return () => {
//       cancelled = true;
//     };
//   }, [optimizationId, finalResumeKey]);

//   const replaceScreening = (updated) =>
//     setScreenings((list) => list.map((s) => (s._id === updated._id ? { ...s, ...updated } : s)));

//   // 1. Generate questions (creates a DRAFT)
//   const handleCreate = async () => {
//     setBusy("create");
//     setError("");
//     try {
//       const { data } = await createScreening(optimizationId);
//       setScreenings((list) => [data.screening, ...list]);
//       setEditing({ id: data.screening._id, questions: data.screening.questions.map((q) => ({ ...q })) });
//       setEditError("");
//     } catch (err) {
//       setError(apiErrorMessage(err, "Couldn't create the screening test."));
//     } finally {
//       setBusy(null);
//     }
//   };

//   // 2. Edit questions in the draft
//   const openEditor = (s) => {
//     setEditing({ id: s._id, questions: s.questions.map((q) => ({ ...q })) });
//     setEditError("");
//   };

//   const updateQuestion = (index, field, value) => {
//     setEditing((e) => ({
//       ...e,
//       questions: e.questions.map((q, i) => (i === index ? { ...q, [field]: value } : q)),
//     }));
//     setEditError("");
//   };

//   const removeQuestion = (index) => {
//     setEditing((e) => ({ ...e, questions: e.questions.filter((_, i) => i !== index) }));
//     setEditError("");
//   };

//   const addQuestion = () => {
//     setEditing((e) => ({
//       ...e,
//       questions: [...e.questions, { qid: "", type: "TECHNICAL", skill: "", text: "", goodAnswer: "" }],
//     }));
//   };

//   const validateDraft = () => {
//     if (!editing.questions.length) return "Keep at least one question.";
//     if (editing.questions.some((q) => !q.text.trim())) return "Fill in or remove the empty question first.";
//     return "";
//   };

//   const saveDraft = async () => {
//     const problem = validateDraft();
//     if (problem) {
//       setEditError(problem);
//       return null;
//     }
//     const { data } = await updateScreeningQuestions(editing.id, editing.questions);
//     replaceScreening(data.screening);
//     return data.screening;
//   };

//   const handleSave = async () => {
//     setBusy(`save:${editing.id}`);
//     try {
//       const saved = await saveDraft();
//       if (saved) setEditing({ id: saved._id, questions: saved.questions.map((q) => ({ ...q })) });
//     } catch (err) {
//       setEditError(apiErrorMessage(err, "Couldn't save the questions."));
//     } finally {
//       setBusy(null);
//     }
//   };

//   // 3. Approve -> link
//   const handleApprove = async () => {
//     setBusy(`send:${editing.id}`);
//     try {
//       const saved = await saveDraft();
//       if (!saved) return;
//       const { data } = await sendScreening(saved._id);
//       replaceScreening(data.screening);
//       setEditing(null);
//     } catch (err) {
//       setEditError(apiErrorMessage(err, "Couldn't create the link."));
//     } finally {
//       setBusy(null);
//     }
//   };

//   const handleCancel = async (s) => {
//     if (!window.confirm("Withdraw this link? The candidate won't be able to open it any more.")) return;
//     setBusy(`cancel:${s._id}`);
//     setError("");
//     try {
//       const { data } = await cancelScreening(s._id);
//       replaceScreening(data.screening);
//     } catch (err) {
//       setError(apiErrorMessage(err, "Couldn't withdraw the link."));
//     } finally {
//       setBusy(null);
//     }
//   };

//   const handleCopy = async (s) => {
//     try {
//       await navigator.clipboard.writeText(s.link);
//       setCopiedId(s._id);
//       setTimeout(() => setCopiedId(null), 1500);
//     } catch {
//       setError("Couldn't copy automatically. Select the link and copy it manually.");
//     }
//   };

//   const firstName = String(candidate.name || "").split(/\s+/)[0] || "there";
//   const hasFinalResume = latestFinalVersion != null || optimization?.status === "COMPLETED" || !!finalResumeKey;

//   return (
//     <div className="scr-panel">
//       <div className="scr-panel-header">
//         <h3>AI screening interview</h3>
//         <button type="button" onClick={handleCreate} disabled={busy === "create" || isDisqualified || !hasFinalResume}>
//           {busy === "create" ? "Writing questions…" : "Create screening test"}
//         </button>
//       </div>
//       <p className="scr-hint">
//         A mock interview on the optimized resume: the AI asks about the claims on the final resume that match this job
//         description, the way the client's interviewer would. Review the questions, send the candidate a link, and they
//         answer by voice. The report shows their scores and which resume claims they still need to practise.
//         {isDisqualified && " Not available because this candidate is disqualified for the job."}
//         {!isDisqualified && !loading && !hasFinalResume && " Generate the final resume first — the questions are based on it."}
//       </p>

//       {busy === "create" && <p className="scr-hint">This takes about 10–30 seconds.</p>}
//       {error && <div className="scr-error">{error}</div>}
//       {loading && <p className="scr-hint">Loading screening tests…</p>}
//       {!loading && screenings.length === 0 && (
//         <p className="scr-hint">No screening tests yet. Create one to get a link for {candidate.name || "the candidate"}.</p>
//       )}

//       {screenings.map((s) => {
//         const isEditing = editing?.id === s._id;
//         const statusLabel = s.isExpired ? "Link expired" : STATUS_LABELS[s.status] || s.status;

//         return (
//           <div className="scr-item" key={s._id}>
//             <div className="scr-item-top">
//               <div>
//                 <span className={`scr-status ${s.isExpired ? "CANCELLED" : s.status}`}>{statusLabel}</span>{" "}
//                 <span className="scr-item-meta">
//                   {s.questions?.length || 0} questions
//                   {s.resumeVersionNumber != null && ` · final resume v${s.resumeVersionNumber}`}
//                   {s.resumeVersionNumber != null && latestFinalVersion != null && latestFinalVersion > s.resumeVersionNumber &&
//                     ` (newer v${latestFinalVersion} exists)`}
//                   {" "}· created {formatDateTime(s.createdAt)}
//                   {s.completedAt && ` · finished ${formatDateTime(s.completedAt)}`}
//                 </span>
//               </div>
//               {s.report && (
//                 <span>
//                   <strong style={{ fontSize: "15px" }}>{s.report.overallScore}/100</strong>{" "}
//                   <span className={`scr-verdict ${s.report.recommendation}`}>{VERDICT_LABELS[s.report.recommendation]}</span>
//                 </span>
//               )}
//             </div>

//             {/* DRAFT: review / edit questions */}
//             {s.status === "DRAFT" && !isEditing && (
//               <div className="scr-actions">
//                 <button type="button" onClick={() => openEditor(s)}>Review questions</button>
//               </div>
//             )}

//             {s.status === "DRAFT" && isEditing && (
//               <div style={{ marginTop: "14px" }}>
//                 {editing.questions.map((q, i) => (
//                   <div className="scr-question-edit" key={i}>
//                     <select value={q.type} onChange={(e) => updateQuestion(i, "type", e.target.value)} aria-label={`Question ${i + 1} type`}>
//                       {TYPE_OPTIONS.map((o) => (
//                         <option key={o.value} value={o.value}>{o.label}</option>
//                       ))}
//                     </select>
//                     <div>
//                       <textarea
//                         value={q.text}
//                         onChange={(e) => updateQuestion(i, "text", e.target.value)}
//                         placeholder="Type the question as the interviewer will say it"
//                         aria-label={`Question ${i + 1}`}
//                       />
//                       {q.skill && <div className="scr-skill">Checks: {q.skill}</div>}
//                     </div>
//                     <button type="button" className="btn-secondary" onClick={() => removeQuestion(i)} style={{ fontSize: "12px", padding: "6px 10px" }}>
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//                 {editError && <div className="scr-error">{editError}</div>}
//                 <div className="scr-actions">
//                   <button type="button" className="btn-secondary" onClick={addQuestion}>Add question</button>
//                   <button type="button" className="btn-secondary" onClick={handleSave} disabled={!!busy}>
//                     {busy === `save:${s._id}` ? "Saving…" : "Save questions"}
//                   </button>
//                   <button type="button" onClick={handleApprove} disabled={!!busy}>
//                     {busy === `send:${s._id}` ? "Creating link…" : "Approve and create link"}
//                   </button>
//                   <button type="button" className="btn-secondary" onClick={() => setEditing(null)} disabled={!!busy}>Close</button>
//                 </div>
//               </div>
//             )}

//             {/* SENT / IN_PROGRESS: share the link */}
//             {s.link && ["SENT", "IN_PROGRESS"].includes(s.status) && !s.isExpired && (
//               <>
//                 <div className="scr-linkbox">
//                   <input value={s.link} readOnly aria-label="Candidate interview link" onFocus={(e) => e.target.select()} />
//                   <button type="button" className="btn-secondary" onClick={() => handleCopy(s)}>
//                     {copiedId === s._id ? "Copied" : "Copy link"}
//                   </button>
//                 </div>
//                 <div className="scr-item-meta" style={{ marginTop: "6px" }}>
//                   Works once · expires {formatDateTime(s.expiresAt)}
//                 </div>
//                 <div className="scr-actions">
//                   <a
//                     className="scr-btn"
//                     style={{ padding: "6px 14px" }}
//                     href={gmailComposeUrl({ email: candidate.email, firstName, jobTitle: s.jobTitle, link: s.link, expiresAt: s.expiresAt })}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     Send with Gmail
//                   </a>
//                   <Link className="scr-btn scr-btn-secondary" style={{ padding: "6px 14px" }} to={`/dashboard/screenings/${s._id}`}>
//                     View answers
//                   </Link>
//                   <button type="button" className="btn-secondary" onClick={() => handleCancel(s)} disabled={!!busy}>
//                     {busy === `cancel:${s._id}` ? "Withdrawing…" : "Withdraw link"}
//                   </button>
//                 </div>
//               </>
//             )}

//             {/* Finished: open the report */}
//             {["COMPLETED", "REPORT_READY", "REPORT_FAILED"].includes(s.status) && (
//               <div className="scr-actions">
//                 <Link className="scr-btn" style={{ padding: "6px 14px" }} to={`/dashboard/screenings/${s._id}`}>
//                   View report
//                 </Link>
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  listScreenings,
  createScreening,
  updateScreeningQuestions,
  sendScreening,
  cancelScreening,
  emailScreeningInvite,
  apiErrorMessage,
  STATUS_LABELS,
  VERDICT_LABELS,
} from "../api/screeningApi";
import { formatDateTime } from "../utils/formatters";
import "../css/Screening.css";

const TYPE_OPTIONS = [
  { value: "TECHNICAL", label: "Technical" },
  { value: "BEHAVIOURAL", label: "Behavioural" },
  { value: "GAP", label: "Gap" },
];

// The invite email is now written and sent by the SERVER from the company
// screening mailbox (see backend/utils/screeningInviteEmail.js), so it never
// comes from the recruiter's own Gmail account.

export default function ScreeningPanel({ optimization }) {
  const optimizationId = optimization?._id || optimization?.id;
  const candidate = optimization?.candidateId || {};
  const isDisqualified = optimization?.eligibility?.status === "DISQUALIFIED";
  // Changes when a final resume is generated on this page, so the panel reloads.
  const finalResumeKey = optimization?.finalResumeVersion?._id || optimization?.finalResumeVersion?.id || "";

  const [screenings, setScreenings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null); // which action is running, e.g. "create" or "send:<id>"
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(null); // { id, questions } for the draft being edited
  const [editError, setEditError] = useState("");
  const [copiedId, setCopiedId] = useState(null);
  const [notice, setNotice] = useState(""); // success message, e.g. "Invite emailed to …"
  const [latestFinalVersion, setLatestFinalVersion] = useState(null);

  useEffect(() => {
    if (!optimizationId) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await listScreenings(optimizationId);
        if (!cancelled) {
          setScreenings(data.screenings || []);
          setLatestFinalVersion(data.latestFinalVersion ?? null);
        }
      } catch (err) {
        if (!cancelled) setError(apiErrorMessage(err, "Couldn't load screening tests."));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [optimizationId, finalResumeKey]);

  const replaceScreening = (updated) =>
    setScreenings((list) => list.map((s) => (s._id === updated._id ? { ...s, ...updated } : s)));

  // 1. Generate questions (creates a DRAFT)
  const handleCreate = async () => {
    setBusy("create");
    setError("");
    try {
      const { data } = await createScreening(optimizationId);
      setScreenings((list) => [data.screening, ...list]);
      setEditing({ id: data.screening._id, questions: data.screening.questions.map((q) => ({ ...q })) });
      setEditError("");
    } catch (err) {
      setError(apiErrorMessage(err, "Couldn't create the screening test."));
    } finally {
      setBusy(null);
    }
  };

  // 2. Edit questions in the draft
  const openEditor = (s) => {
    setEditing({ id: s._id, questions: s.questions.map((q) => ({ ...q })) });
    setEditError("");
  };

  const updateQuestion = (index, field, value) => {
    setEditing((e) => ({
      ...e,
      questions: e.questions.map((q, i) => (i === index ? { ...q, [field]: value } : q)),
    }));
    setEditError("");
  };

  const removeQuestion = (index) => {
    setEditing((e) => ({ ...e, questions: e.questions.filter((_, i) => i !== index) }));
    setEditError("");
  };

  const addQuestion = () => {
    setEditing((e) => ({
      ...e,
      questions: [...e.questions, { qid: "", type: "TECHNICAL", skill: "", text: "", goodAnswer: "" }],
    }));
  };

  const validateDraft = () => {
    if (!editing.questions.length) return "Keep at least one question.";
    if (editing.questions.some((q) => !q.text.trim())) return "Fill in or remove the empty question first.";
    return "";
  };

  const saveDraft = async () => {
    const problem = validateDraft();
    if (problem) {
      setEditError(problem);
      return null;
    }
    const { data } = await updateScreeningQuestions(editing.id, editing.questions);
    replaceScreening(data.screening);
    return data.screening;
  };

  const handleSave = async () => {
    setBusy(`save:${editing.id}`);
    try {
      const saved = await saveDraft();
      if (saved) setEditing({ id: saved._id, questions: saved.questions.map((q) => ({ ...q })) });
    } catch (err) {
      setEditError(apiErrorMessage(err, "Couldn't save the questions."));
    } finally {
      setBusy(null);
    }
  };

  // 3. Approve -> link
  const handleApprove = async () => {
    setBusy(`send:${editing.id}`);
    try {
      const saved = await saveDraft();
      if (!saved) return;
      const { data } = await sendScreening(saved._id);
      replaceScreening(data.screening);
      setEditing(null);
    } catch (err) {
      setEditError(apiErrorMessage(err, "Couldn't create the link."));
    } finally {
      setBusy(null);
    }
  };

  const handleCancel = async (s) => {
    if (!window.confirm("Withdraw this link? The candidate won't be able to open it any more.")) return;
    setBusy(`cancel:${s._id}`);
    setError("");
    try {
      const { data } = await cancelScreening(s._id);
      replaceScreening(data.screening);
    } catch (err) {
      setError(apiErrorMessage(err, "Couldn't withdraw the link."));
    } finally {
      setBusy(null);
    }
  };

  // 4. Email the link to the candidate from the company mailbox
  const handleEmail = async (s) => {
    const to = candidate.email || "the candidate";
    const question = s.emailedAt
      ? `Resend the invite to ${to}? They were already emailed on ${formatDateTime(s.emailedAt)}.`
      : `Email the interview link to ${to}?`;
    if (!window.confirm(question)) return;

    setBusy(`email:${s._id}`);
    setError("");
    setNotice("");
    try {
      const { data } = await emailScreeningInvite(s._id);
      replaceScreening(data.screening);
      setNotice(data.message || `Invite emailed to ${to}.`);
    } catch (err) {
      setError(apiErrorMessage(err, "Couldn't send the email."));
    } finally {
      setBusy(null);
    }
  };

  const handleCopy = async (s) => {
    try {
      await navigator.clipboard.writeText(s.link);
      setCopiedId(s._id);
      setTimeout(() => setCopiedId(null), 1500);
    } catch {
      setError("Couldn't copy automatically. Select the link and copy it manually.");
    }
  };

  const hasFinalResume = latestFinalVersion != null || optimization?.status === "COMPLETED" || !!finalResumeKey;

  return (
    <div className="scr-panel">
      <div className="scr-panel-header">
        <h3>AI screening interview</h3>
        <button type="button" onClick={handleCreate} disabled={busy === "create" || isDisqualified || !hasFinalResume}>
          {busy === "create" ? "Writing questions…" : "Create screening test"}
        </button>
      </div>
      <p className="scr-hint">
        A mock interview on the optimized resume: the AI asks about the claims on the final resume that match this job
        description, the way the client's interviewer would. Review the questions, send the candidate a link, and they
        answer by voice. The report shows their scores and which resume claims they still need to practise.
        {isDisqualified && " Not available because this candidate is disqualified for the job."}
        {!isDisqualified && !loading && !hasFinalResume && " Generate the final resume first — the questions are based on it."}
      </p>

      {busy === "create" && <p className="scr-hint">This takes about 10–30 seconds.</p>}
      {error && <div className="scr-error">{error}</div>}
      {notice && (
        <div
          style={{
            marginTop: "8px",
            padding: "8px 12px",
            backgroundColor: "#e6f4ea",
            color: "#1e7e34",
            border: "1px solid #b7dfc1",
            borderRadius: "4px",
            fontSize: "13px",
          }}
        >
          {notice}
        </div>
      )}
      {loading &&<p className="scr-hint">Loading screening tests…</p>}
      {!loading && screenings.length === 0 && (
        <p className="scr-hint">No screening tests yet. Create one to get a link for {candidate.name || "the candidate"}.</p>
      )}

      {screenings.map((s) => {
        const isEditing = editing?.id === s._id;
        const statusLabel = s.isExpired ? "Link expired" : STATUS_LABELS[s.status] || s.status;

        return (
          <div className="scr-item" key={s._id}>
            <div className="scr-item-top">
              <div>
                <span className={`scr-status ${s.isExpired ? "CANCELLED" : s.status}`}>{statusLabel}</span>{" "}
                <span className="scr-item-meta">
                  {s.questions?.length || 0} questions
                  {s.resumeVersionNumber != null && ` · final resume v${s.resumeVersionNumber}`}
                  {s.resumeVersionNumber != null && latestFinalVersion != null && latestFinalVersion > s.resumeVersionNumber &&
                    ` (newer v${latestFinalVersion} exists)`}
                  {" "}· created {formatDateTime(s.createdAt)}
                  {s.completedAt && ` · finished ${formatDateTime(s.completedAt)}`}
                </span>
              </div>
              {s.report && (
                <span>
                  <strong style={{ fontSize: "15px" }}>{s.report.overallScore}/100</strong>{" "}
                  <span className={`scr-verdict ${s.report.recommendation}`}>{VERDICT_LABELS[s.report.recommendation]}</span>
                </span>
              )}
            </div>

            {/* DRAFT: review / edit questions */}
            {s.status === "DRAFT" && !isEditing && (
              <div className="scr-actions">
                <button type="button" onClick={() => openEditor(s)}>Review questions</button>
              </div>
            )}

            {s.status === "DRAFT" && isEditing && (
              <div style={{ marginTop: "14px" }}>
                {editing.questions.map((q, i) => (
                  <div className="scr-question-edit" key={i}>
                    <select value={q.type} onChange={(e) => updateQuestion(i, "type", e.target.value)} aria-label={`Question ${i + 1} type`}>
                      {TYPE_OPTIONS.map((o) => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                      ))}
                    </select>
                    <div>
                      <textarea
                        value={q.text}
                        onChange={(e) => updateQuestion(i, "text", e.target.value)}
                        placeholder="Type the question as the interviewer will say it"
                        aria-label={`Question ${i + 1}`}
                      />
                      {q.skill && <div className="scr-skill">Checks: {q.skill}</div>}
                    </div>
                    <button type="button" className="btn-secondary" onClick={() => removeQuestion(i)} style={{ fontSize: "12px", padding: "6px 10px" }}>
                      Remove
                    </button>
                  </div>
                ))}
                {editError && <div className="scr-error">{editError}</div>}
                <div className="scr-actions">
                  <button type="button" className="btn-secondary" onClick={addQuestion}>Add question</button>
                  <button type="button" className="btn-secondary" onClick={handleSave} disabled={!!busy}>
                    {busy === `save:${s._id}` ? "Saving…" : "Save questions"}
                  </button>
                  <button type="button" onClick={handleApprove} disabled={!!busy}>
                    {busy === `send:${s._id}` ? "Creating link…" : "Approve and create link"}
                  </button>
                  <button type="button" className="btn-secondary" onClick={() => setEditing(null)} disabled={!!busy}>Close</button>
                </div>
              </div>
            )}

            {/* SENT / IN_PROGRESS: share the link */}
            {s.link && ["SENT", "IN_PROGRESS"].includes(s.status) && !s.isExpired && (
              <>
                <div className="scr-linkbox">
                  <input value={s.link} readOnly aria-label="Candidate interview link" onFocus={(e) => e.target.select()} />
                  <button type="button" className="btn-secondary" onClick={() => handleCopy(s)}>
                    {copiedId === s._id ? "Copied" : "Copy link"}
                  </button>
                </div>
                <div className="scr-item-meta" style={{ marginTop: "6px" }}>
                  Works once · expires {formatDateTime(s.expiresAt)}
                  {s.emailedAt
                    ? ` · emailed to ${s.emailedTo} on ${formatDateTime(s.emailedAt)}${s.emailedFrom ? ` from ${s.emailedFrom}` : ""}${
                        s.emailCount > 1 ? ` (sent ${s.emailCount} times)` : ""
                      }`
                    : " · not emailed yet"}
                </div>
                <div className="scr-actions">
                  {s.status === "SENT" && (
                    <button
                      type="button"
                      onClick={() => handleEmail(s)}
                      disabled={!!busy || !candidate.email}
                      title={candidate.email ? `Sends from the company screening mailbox to ${candidate.email}` : "Add the candidate's email first"}
                    >
                      {busy === `email:${s._id}` ? "Sending…" : s.emailedAt ? "Resend email" : "Email invite to candidate"}
                    </button>
                  )}
                  <Link className="scr-btn scr-btn-secondary" style={{ padding: "6px 14px" }} to={`/dashboard/screenings/${s._id}`}>
                    View answers
                  </Link>
                  <button type="button" className="btn-secondary" onClick={() => handleCancel(s)} disabled={!!busy}>
                    {busy === `cancel:${s._id}` ? "Withdrawing…" : "Withdraw link"}
                  </button>
                </div>
              </>
            )}

            {/* Finished: open the report */}
            {["COMPLETED", "REPORT_READY", "REPORT_FAILED"].includes(s.status) && (
              <div className="scr-actions">
                <Link className="scr-btn" style={{ padding: "6px 14px" }} to={`/dashboard/screenings/${s._id}`}>
                  View report
                </Link>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
